module.exports = __webpack_public_path__ + "static/media/HistoryReport.0425c4e5.png";